import { render, staticRenderFns } from "./TaskHeaderWidget.vue?vue&type=template&id=59a593ed&"
import script from "./TaskHeaderWidget.vue?vue&type=script&lang=js&"
export * from "./TaskHeaderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports